import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { RequestSubForm } from '../request-sub-form.component';

@Component({
    selector: 'retrieve-load-request-form',
    templateUrl: './retrieve-load-request-form.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RetrieveLoadRequestFormComponent extends RequestSubForm {
  pageName = 'RequestRetrieveLoad';
}
